import api, { ResponsePayloadWithData } from '../../../api';

export interface License {
  id: string;
  description: string;
  isbn: string;
  licenseCode: string;
  name: string;
  subject: string;
  validFrom: string;
  validTo: string;
  replaced: boolean;
}

export const LICENSE_TRANSFER_DIRECTION = {
  SENDER: 'sender',
  RECEIVER: 'receiver',
} as const;

export interface LicenseTransfer {
  id: string;
  direction: typeof LICENSE_TRANSFER_DIRECTION[keyof typeof LICENSE_TRANSFER_DIRECTION];
  email: string;
  license: License;
}

export async function getLicenses() {
  const {
    data: { data },
  } = await api.get<ResponsePayloadWithData<License[]>>('/studio/user/licenses');

  return data;
}

export async function getLicenseTransfers() {
  const {
    data: { data },
  } = await api.get<ResponsePayloadWithData<LicenseTransfer[]>>('studio/licenses/transfers');

  return data;
}

export async function startLicenseTransfer(email: string, licenseId: string) {
  const { data } = await api.post<LicenseTransfer>('studio/licenses/transfers', {
    email,
    licenseId,
  });

  return data;
}

export async function cancelLicenseTransfer(transferId: string) {
  await api.delete(`studio/licenses/transfers/${transferId}`);
}

export async function acceptLicenseTransfer(transferId: string) {
  const { data } = await api.put<{ needsRefreshToken: boolean }>(`studio/licenses/transfers/${transferId}/accept`);

  return data;
}

export async function declineLicenseTransfer(transferId: string) {
  await api.delete(`studio/licenses/transfers/${transferId}/decline`);
}
